import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const PublicProvidentFund = () => {
  return (
    <>
      <TopBanner content={"Public Provident Fund"} />
      <ContentWrapper>
        <div className="text-content">
          <h3>India’s Most Trusted Long-Term Savings Plan</h3>
          <p>
            The Public Provident Fund (PPF) is a government-backed savings
            scheme that helps you grow your money safely over time with
            guaranteed returns and tax benefits. It’s ideal for people who want
            to save for retirement, children’s future, or just build wealth
            slowly and securely.
          </p>

          <h3>Why Choose PPF?</h3>
          <ul>
            <li>Backed by the Government of India</li>
            <li>Interest is completely tax-free</li>
            <li>Lock-in period of 15 years ensures discipline</li>
            <li>Start with as little as ₹500 per year</li>
            <li>Safe, stable, and ideal for long-term goals</li>
          </ul>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default PublicProvidentFund;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
